import { Flex, HelpButton, tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';
import { CalculationDetailRow } from './types';

type Props = {
  rows: CalculationDetailRow[];
};

export function CalculationDetails({ rows }: Props) {
  const { t } = useTranslation();

  return (
    <Flex flexDirection={'column'} gap={tokens.size.spacingXs.value}>
      {rows.map(
        ({
          key,
          labelKey,
          value,
          valueKey,
          valueParams,
          isBold,
          tooltipKey,
          testId,
        }) => {
          const fontWeight = isBold
            ? tokens.font.weightDefaultMedium.value
            : undefined;

          return (
            <Flex
              key={key}
              justifyContent={'space-between'}
              alignItems={'center'}
              gap={tokens.size.spacingMd.value}
            >
              <Flex alignItems={'center'} gap={tokens.size.spacing3xs.value}>
                <Typography.Body size={'sm'} fontWeight={fontWeight}>
                  {t(labelKey)}
                </Typography.Body>
                {tooltipKey && (
                  <HelpButton
                    variant={'help'}
                    aria-label={t(
                      'shared:moreInformation.items.calculationDetails.helpButtonLabel',
                    )}
                    contentBody={
                      <Typography.Body size={'sm'}>
                        {t(tooltipKey)}
                      </Typography.Body>
                    }
                  />
                )}
              </Flex>
              <Typography.Body
                size={'sm'}
                fontWeight={fontWeight}
                textAlign={'right'}
                data-test-id={testId}
                UNSAFE_style={{ flexShrink: 0 }}
              >
                {value ?? t(valueKey ?? '', valueParams)}
              </Typography.Body>
            </Flex>
          );
        },
      )}
    </Flex>
  );
}
